import axios from '../../axios'

export function reportsGetStatictics() {
  return async (dispatch) => {
    try {
      const response = await axios.get('Reports/statistics')
      dispatch({
        type: 'REPORTS_STATISTICS_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'REPORTS_STATISTICS_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function reportsGetActives(skip, limit) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Reports/active?offset=${skip}&limit=${limit}`
      )
      dispatch({
        type: 'REPORTS_ACTIVE_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'REPORTS_ACTIVE_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}

export function reportsActivesRead(id) {
  return async (dispatch) => {
    try {
      await axios.patch(`Reports/${id}/read`, null)
    } catch (e) {
      dispatch({
        type: 'REPORTS_READ_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function reportsActivesUnread(id) {
  return async (dispatch) => {
    try {
      await axios.patch(`Reports/${id}/unread`, null)
    } catch (e) {
      dispatch({
        type: 'REPORTS_UNREAD_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function reportsActivesDelete(id, cb = () => {}) {
  return async (dispatch) => {
    try {
      await axios.patch(`Reports/${id}/archive`, null)
      cb(null)
    } catch (e) {
      dispatch({
        type: 'REPORTS_ARCHIVE_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
      cb(e)
    }
  }
}
export function reportsActionNew(id, text) {
  return async (dispatch) => {
    try {
      await axios.post(`Reports/${id}/actions`, { remark: text })
    } catch (e) {
      dispatch({
        type: 'REPORTS_ACTION_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}

export function reportsActivesOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ACTIVES_ITEMPERPAGE',
      payload: {
        count,
      },
    })
  }
}
export function reportsActivesOnCurrentPageChanged(page) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ACTIVE_CURRENTPAGE',
      payload: {
        page,
      },
    })
  }
}

export function reportsGetArchived(skip, limit) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Reports/archived?offset=${skip}&limit=${limit}`
      )
      dispatch({
        type: 'REPORTS_ARCHIVED_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'REPORTS_ARCHIVED_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function reportsArchivedOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ARCHIVED_ITEMPERPAGE',
      payload: {
        count,
      },
    })
  }
}
export function reportsArchivedOnCurrentPageChanged(page) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ARCHIVED_CURRENTPAGE',
      payload: {
        page,
      },
    })
  }
}
export function reportsArchivedUnbox(id) {
  return async (dispatch) => {
    try {
      await axios.patch(`Reports/${id}/unarchive`, null)
    } catch (e) {
      dispatch({
        type: 'REPORTS_UNARCHIVED_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}

// MQTT triggered
export function reportsActiveNew(data) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ACTIVE_NEW',
      payload: { data },
    })
  }
}
export function reportsActivesReadDone(data) {
  return async (dispatch) => {
    dispatch({
      type: 'REPORTS_READ_FULFILLED',
      payload: {
        data: data,
        error: null,
      },
    })
  }
}
export function reportsActivesUnreadDone(data) {
  return async (dispatch) => {
    dispatch({
      type: 'REPORTS_UNREAD_FULFILLED',
      payload: {
        data: data,
        error: null,
      },
    })
  }
}
export function reportsActivesDeleteDone(data) {
  return async (dispatch) => {
    dispatch({
      type: 'REPORTS_ARCHIVE_FULFILLED',
      payload: {
        data: data,
        error: null,
      },
    })
  }
}
export function reportsActionFulfilled(data) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_ACTION_NEW',
      payload: {
        data,
      },
    })
  }
}
export function reportsArchivedUnboxDone(data) {
  return (dispatch) => {
    dispatch({
      type: 'REPORTS_UNARCHIVED_FULFILLED',
      payload: {
        data: data,
        error: null,
      },
    })
  }
}
